import * as React from 'react'
import { isEmpty } from 'lodash'
import actions from 'actions/formInstances'
import { getChangedItems } from 'helpers/formViews'
import { showError, showClientNotifications } from 'helpers/errors'
import { Emitter } from 'helpers/events'
import { FORM_INSTANCES_REFRESH } from 'options/events'

export const createFormInstanceAttachmentsDispatchToProps = (dispatch) => ({
  getAttachments: (formInstanceId, params) => dispatch(actions.getAttachments(formInstanceId, params)),
  createAttachments: (formInstanceId, params) => dispatch(actions.createAttachments(formInstanceId, params)),
  deleteAttachments: (formInstanceId, params) => dispatch(actions.deleteAttachments(formInstanceId, params)),
  downloadAttachment: (formInstanceId, params) =>
    dispatch(actions.downloadAttachment(formInstanceId, params)),
  downloadAttachments: (formInstanceId) => dispatch(actions.downloadAttachments(formInstanceId)),
})

export const createSaveFormInstances =
  (self, { objectType }) =>
  async (formInstanceItems) => {
    const { deleting } = getChangedItems(self.state.formInstanceItemsOriginal, formInstanceItems)

    if (!isEmpty(deleting)) {
      try {
        const response = await self.props.deleteFormInstanceItems(deleting.map((each) => each.id))

        showClientNotifications({ response })
      } catch (error) {
        showError({ error })
      }
    }

    Emitter.emit(FORM_INSTANCES_REFRESH)
  }

export const createRefreshFormInstances =
  (self, { objectType }) =>
  async () => {
    try {
      const response = await self.props.getFormInstanceItems({ objectId: self.state.item.id, objectType })

      self.setState({
        formInstanceItems: response?.value?.data?.items,
        formInstanceItemsOriginal: response?.value?.data?.items,
      })
    } catch (error) {
      showError({ error })
    }
  }

export const FormInstancesContext = React.createContext({})
